import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, ConfigState } from '../../../models';

import { CONFIG_CONSTS } from '../../../store/config/config.consts';

export class LoadInstancesAction implements ActionClass {

  public static async execute({ commit }: ActionContext<ConfigState, any>): Promise<Instance[]> {
    try {
      const instances = await CONTAINER.get<Promise<Instance[]>>(TYPES.Instances);
      commit(CONFIG_CONSTS.mutations.setInstances, instances);
      return instances;
    } catch (error) {}
  }

}
